(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Scroll para hash na URL
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Ordenar produtos por metafield de ordem (custom.ordem_exibicao)
  (function() {
    function ordenarProdutosPorMetafield() {
      const productGrid = document.querySelector('.product-grid') || 
                         document.querySelector('ul[class*="product"]') ||
                         document.querySelector('results-list ul');
      
      if (!productGrid) return;
      
      const items = Array.from(productGrid.querySelectorAll('li[data-ordem]'));
      if (items.length === 0) return;
      
      // Ordenar por data-ordem (menor valor primeiro)
      items.sort((a, b) => {
        const ordemA = parseInt(a.getAttribute('data-ordem')) || 9999;
        const ordemB = parseInt(b.getAttribute('data-ordem')) || 9999;
        return ordemA - ordemB;
      });
      
      // Reorganizar no DOM
      items.forEach(item => productGrid.appendChild(item));
    }
    
    // Executar quando a página carregar
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ordenarProdutosPorMetafield);
    } else {
      ordenarProdutosPorMetafield();
    }
    
    // Executar após mudanças dinâmicas
    setTimeout(ordenarProdutosPorMetafield, 1000);
    setTimeout(ordenarProdutosPorMetafield, 2000);
  })();

  } catch(e) { console.error(e); }
})();
})();
